import React from 'react';
import { SmartLink } from './SmartLink';
export function DemoCta() {
  return <section data-nav-theme="dark" className="w-full bg-ink" aria-labelledby="demo-heading" data-id="element-375" data-mp="2u1xyek77calg">
      <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-376" data-mp="2gassx1h5ko37">
        <div className="flex items-center justify-center px-6 py-16 lg:py-24" data-id="element-377" data-mp="2gab0yh1iww13">
          <div className="w-full max-w-[460px]" data-id="element-378" data-mp="2kbcs0alae1rz">
            <h2 id="demo-heading" className="display text-[32px] font-semibold text-white sm:text-[40px]" data-id="element-379" data-mp="2ka1p0czo0y1x">
              See what Kayko can do for your business.
            </h2>
            <p className="mt-5 max-w-[400px] text-[16px] leading-[1.55] text-white/70" data-id="element-380" data-mp="1xc86vnu4c8wf">
              Manage your sales, stock, expenses, and finances from one connected platform.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-3" data-id="element-381" data-mp="3rq9464a0snue">
              <SmartLink href="/get-started" className="inline-flex rounded-[7px] bg-brand px-5 py-3 text-[15px] font-semibold text-white transition-colors duration-150 ease-out hover:bg-brand-hover" data-id="element-382" data-mp="3rnv93vfcbbmu">
                Get started
              </SmartLink>
              <SmartLink href="/demo" className="inline-flex rounded-[7px] border border-white/30 px-5 py-3 text-[15px] font-semibold text-white transition-colors duration-150 ease-out hover:border-white/70" data-id="element-383" data-mp="2hcs93buhcw1t">
                Book a demo
              </SmartLink>
            </div>
          </div>
        </div>

        <img src="https://cdn.magicpatterns.com/uploads/wg4VPY1eFKgSEnh2TpMTLw/image.png" alt="Kayko advisor showing a café owner her business dashboard on a laptop" style={{
        objectPosition: '70% 30%'
      }} className="h-[300px] w-full object-cover sm:h-[380px] lg:h-full lg:min-h-[460px]" data-id="element-384" data-mp="1yh24dgv5xlk8" />
      </div>
    </section>;
}